'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseComponent2 = require('../../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _Fallback = require('../../base/Fallback');

var _Fallback2 = _interopRequireDefault(_Fallback);

var _ButtonClear = require('../../button/ButtonClear');

var _ButtonClear2 = _interopRequireDefault(_ButtonClear);

var _ConfigGlobal = require('../../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _IconComponent = require('../../icon/IconComponent');

var _IconComponent2 = _interopRequireDefault(_IconComponent);

var _WrapMenuList = require('./WrapMenuList');

var _WrapMenuList2 = _interopRequireDefault(_WrapMenuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loadable = _component2.default.lib(function () {
  return import("../../lib/react-select/dist/react-select.esm");
});

var initialCache = {
  isFirstLoad: true,
  options: [],
  hasMore: true,
  isLoading: false
};

var ClearIndicator = function ClearIndicator(props) {
  var _props$innerProps = props.innerProps,
      ref = _props$innerProps.ref,
      restInnerProps = (0, _objectWithoutProperties3.default)(_props$innerProps, ['ref']);

  return _react2.default.createElement(_ButtonClear2.default, (0, _extends6.default)({}, restInnerProps, { ref: ref }));
};

var AsyncPaginate = function (_BaseComponent) {
  (0, _inherits3.default)(AsyncPaginate, _BaseComponent);

  function AsyncPaginate(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, AsyncPaginate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AsyncPaginate.__proto__ || (0, _getPrototypeOf2.default)(AsyncPaginate)).call(this, props));

    _this.onMenuClose = function () {
      _this.setState({
        search: '',
        menuIsOpen: false
      });
    };

    _this.onMenuOpen = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var optionsCache;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState({
                menuIsOpen: true
              });

            case 2:
              optionsCache = _this.state.optionsCache;

              if (optionsCache['']) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return _this.loadOptions();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.onInputChange = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(search) {
        var onInputChange, optionsCache;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                onInputChange = _this.props.onInputChange;

                onInputChange && onInputChange(search);
                _context2.next = 4;
                return _this.setState({
                  search: search
                });

              case 4:
                optionsCache = _this.state.optionsCache;

                if (optionsCache[search]) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 8;
                return _this.loadOptions();

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleScrolledToBottom = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      var _this$state, search, optionsCache, currentOptions;

      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state = _this.state, search = _this$state.search, optionsCache = _this$state.optionsCache;
              currentOptions = optionsCache[search];

              if (!currentOptions) {
                _context3.next = 5;
                break;
              }

              _context3.next = 5;
              return _this.loadOptions();

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));


    var initialOptionsCache = props.options ? {
      '': {
        isFirstLoad: false,
        isLoading: false,
        options: props.options,
        hasMore: true
      }
    } : {};

    _this.state = {
      search: '',
      optionsCache: initialOptionsCache,
      menuIsOpen: false
    };
    _this.dataTestID = 'async-paginate';
    return _this;
  }

  (0, _createClass3.default)(AsyncPaginate, [{
    key: 'loadOptions',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var _state, search, optionsCache, currentOptions, hasError, options, hasMore, _loadOptions, response;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _state = this.state, search = _state.search, optionsCache = _state.optionsCache;
                currentOptions = optionsCache[search] || initialCache;

                if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _context4.next = 6;
                return this.setState(function (prevState) {
                  return {
                    search: search,
                    optionsCache: (0, _extends6.default)({}, prevState.optionsCache, (0, _defineProperty3.default)({}, search, (0, _extends6.default)({}, currentOptions, {
                      isLoading: true
                    })))
                  };
                });

              case 6:
                hasError = void 0;
                options = void 0;
                hasMore = void 0;
                _context4.prev = 9;
                _loadOptions = this.props.loadOptions;
                _context4.next = 13;
                return _loadOptions(search, currentOptions.options);

              case 13:
                response = _context4.sent;
                options = response.options;
                hasMore = response.hasMore;


                hasError = false;
                _context4.next = 22;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4['catch'](9);

                hasError = true;

              case 22:
                if (!hasError) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 25;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: (0, _extends6.default)({}, prevState.optionsCache, (0, _defineProperty3.default)({}, search, (0, _extends6.default)({}, currentOptions, {
                      isLoading: false
                    })))
                  };
                });

              case 25:
                _context4.next = 29;
                break;

              case 27:
                _context4.next = 29;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: (0, _extends6.default)({}, prevState.optionsCache, (0, _defineProperty3.default)({}, search, (0, _extends6.default)({}, currentOptions, {
                      options: currentOptions.options.concat(options),
                      hasMore: !!hasMore,
                      isLoading: false,
                      isFirstLoad: false
                    })))
                  };
                });

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[9, 19]]);
      }));

      function loadOptions() {
        return _ref4.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          selectRef = _props.selectRef,
          components = _props.components,
          isDisabled = _props.isDisabled,
          isClearable = _props.isClearable,
          visibleIcon = _props.visibleIcon,
          isSearchable = _props.isSearchable,
          disabled = _props.disabled,
          readOnly = _props.readOnly,
          style = _props.style,
          className = _props.className;
      var _state2 = this.state,
          search = _state2.search,
          optionsCache = _state2.optionsCache,
          menuIsOpen = _state2.menuIsOpen;


      var currentOptions = optionsCache[search] || initialCache;

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('body-wrap', className, {
            'input-disabled': disabled,
            'read-only': readOnly,
            'combox-virtualized': this.props.virtualized
          }),
          style: style
        },
        _react2.default.createElement(
          Loadable,
          { fallback: _react2.default.createElement(_Fallback2.default, null) },
          function (props) {
            var SelectBase = props.SelectBase;

            var MenuList = (0, _WrapMenuList2.default)(props.components.MenuList);
            return _react2.default.createElement(SelectBase, (0, _extends6.default)({}, _this3.props, {
              isClearable: isClearable,
              isSearchable: isSearchable,
              isDisabled: isDisabled,
              inputValue: search,
              menuIsOpen: menuIsOpen,
              onMenuClose: _this3.onMenuClose,
              onMenuOpen: _this3.onMenuOpen,
              onInputChange: _this3.onInputChange,
              onMenuScrollToBottom: _this3.handleScrolledToBottom,
              handleScrolledToBottom: _this3.handleScrolledToBottom,
              isLoading: currentOptions.isLoading,
              isFirstLoad: currentOptions.isFirstLoad,
              options: currentOptions.options,
              components: (0, _extends6.default)({
                MenuList: MenuList,
                ClearIndicator: ClearIndicator,
                DropdownIndicator: function DropdownIndicator() {
                  return visibleIcon ? _react2.default.createElement(_IconComponent2.default, {
                    iconCls: _this3.props.iconCls,
                    iconType: _this3.props.iconType || _lodash2.default.get(_ConfigGlobal2.default, 'iconType.select'),
                    iconLine: _this3.props.iconLine
                  }) : null;
                },
                IndicatorSeparator: ''
              }, components),
              ref: selectRef,
              styles: {
                option: function option(provided) {
                  return (0, _extends6.default)({}, provided, {
                    padding: '5px 8px',
                    cursor: 'pointer'
                  });
                },
                menuList: function menuList(provided) {
                  return (0, _extends6.default)({}, provided, {
                    padding: 0
                  });
                }
              }
            }));
          }
        )
      );
    }
  }]);
  return AsyncPaginate;
}(_BaseComponent3.default);

AsyncPaginate.propTypes = {
  loadOptions: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cacheUniq: _propTypes2.default.any,
  selectRef: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object),
  components: _propTypes2.default.objectOf(_propTypes2.default.func),
  iconCls: _propTypes2.default.string
};
AsyncPaginate.defaultProps = {
  cacheUniq: null,
  selectRef: function selectRef() {},
  options: null,
  components: {},
  iconCls: "",
  iconType: "caret-down"
};
exports.default = AsyncPaginate;